import Reservations from "./Reservations";

const RidesCompleted = () => {
  return (
    <>
      <Reservations status="completed" />
    </>
  );
};

export default RidesCompleted;
